import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const CREATIVE_VIDEO_REPORT_ID = `creative${VIDEO_CAMPAIGN_SUFFIX}`;
